import { sendEvent } from '@utils/core/track';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useState } from 'react';
import styles from './styles.scss';

const CurriculumSection: FC = () => {
	const { width } = useResizeObserver()
	const [activeIndex, setActiveIndex] = useState(0);
	const { transData, list } = useTranslation('happyKids.curriculum');
	const ListRenderImg = list.map((item, index) => {
		return (
			<div
				key={index}
				className={classnames(styles['li-item'], styles['li-item-' + item.id], index === activeIndex && styles['active'])}
			>
				<div onClick={() => {
					setActiveIndex(0)
					sendEvent({ eventId: 'ACW_hk_subjecttab' })
				}} className={classnames(styles['btn'], styles['btn-1'])}></div>
				<div onClick={() => {
					setActiveIndex(1)
					sendEvent({ eventId: 'ACW_hk_subjecttab' })
				}} className={classnames(styles['btn'], styles['btn-2'])}></div>
				<img src={width < 768 ? item.pImg : item.img} alt="" />
			</div>
		)
	})




	return (
		<section className={styles['ac-curriculum']}>
			<div className={styles['ac-curriculum-container']}>
				<img className={styles['ac-curriculum-img-1']} src="https://web-data.zmlearn.com/image/ugTSjyHFhUsuZXhr9cTeug/P3-left-bg%402x.png" alt="" loading='lazy' />
				<img className={styles['ac-curriculum-img-2']} src="https://web-data.zmlearn.com/image/i4uc8ywMDwKgaNrVeFTwBZ/%E8%B7%AF%E5%BE%84%402x.png" alt="" loading='lazy' />
				<h1><span>{transData.title}</span></h1>
				<div className={styles['ac-curriculum-list']}
				>{ListRenderImg}</div>
			</div>
		</section >
	);
}

export default CurriculumSection
